// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

import BusinessDetailsActionTypes from './business-details.types';

export const businessDetailsEditStart = (isEdit: any) => ({
	type: BusinessDetailsActionTypes.IS_EDIT_BUSINESS_DETAILS,
	payload: isEdit,
});

export const updateTabValueStart = (updatedTab: any) => ({
	type: BusinessDetailsActionTypes.BUSINESS_SUBMIT_TAB_VALUE_CHANGED,
	payload: updatedTab,
});

export const updateCanvasValueStart = (canvas: any) => ({
	type: BusinessDetailsActionTypes.BUSINESS_IS_OPEN_OFFCANVAS,
	payload: canvas,
});

/** ***************** ADD BUSINESS DETAILS START *********************** */
export const addBusinessDetailsStart = (businessData: any) => ({
	type: BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_START,
	payload: businessData,
});

export const addBusinessDetailsSuccess = (successValue: any) => ({
	type: BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_SUCCESS,
	payload: successValue,
});

export const addBusinessDetailsFailure = (failureData: any) => ({
	type: BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_FAILURE,
	payload: failureData,
});

export const addBusinessDetailsResponseResetStart = () => ({
	type: BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_RESPONSE_RESET,
});

export const addBusinessDetailsResponseChanged = () => ({
	type: BusinessDetailsActionTypes.ADD_BUSINESS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD BUSINESS DETAILS END *********************** */

/** ***************** GET ALL BUSINESS LIST START *********************** */
export const updateBusinessDetailsStart = (updateData: any) => ({
	type: BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_START,
	payload: updateData,
});

export const updateBusinessDetailsSuccess = (updateSuccess: any) => ({
	type: BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_SUCCESS,
	payload: updateSuccess,
});

export const updateBusinessDetailsFailure = (updateFailure: any) => ({
	type: BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_FAILURE,
	payload: updateFailure,
});

export const updateBusinessDetailsResponseResetStart = () => ({
	type: BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_RESPONSE_RESET,
});

export const updateBusinessDetailsResponseChanged = () => ({
	type: BusinessDetailsActionTypes.UPDATE_BUSINESS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ALL BUSINESS LIST END *********************** */

/** ***************** GET ALL BUSINESS LIST START *********************** */
export const fetchBusinessDetailsStart = (fetchData: any) => ({
	type: BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_START,
	payload: fetchData,
});

export const fetchBusinessDetailsSuccess = (fetchSuccess: any) => ({
	type: BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_SUCCESS,
	payload: fetchSuccess,
});

export const fetchBusinessDetailsFailure = (fetchFailure: any) => ({
	type: BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_FAILURE,
	payload: fetchFailure,
});

export const fetchBusinessDetailsResponseResetStart = () => ({
	type: BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_RESPONSE_RESET,
});

export const fetchBusinessDetailsResponseChanged = () => ({
	type: BusinessDetailsActionTypes.FETCH_BUSINESS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ALL BUSINESS LIST END *********************** */

/** ***************** GET ALL BUSINESS LIST START *********************** */
export const deleteBusinessStart = (deleteData: any) => ({
	type: BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_START,
	payload: deleteData,
});

export const deleteBusinessSuccess = (deleteSuccess: any) => ({
	type: BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_SUCCESS,
	payload: deleteSuccess,
});

export const deleteBusinessFailure = (deleteFailure: any) => ({
	type: BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_FAILURE,
	payload: deleteFailure,
});

export const deleteBusinessResponseResetStart = () => ({
	type: BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_RESPONSE_RESET,
});

export const deleteBusinessResponseChanged = () => ({
	type: BusinessDetailsActionTypes.DELETE_BUSINESS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET ALL BUSINESS LIST END *********************** */

/** ***************** GET ALL BUSINESS LIST START *********************** */
export const getAllBusinessListStart = (fetchData: any) => ({
	type: BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_START,
	payload: fetchData,
});

export const getAllBusinessListSuccess = (fetchSuccess: any) => ({
	type: BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_SUCCESS,
	payload: fetchSuccess,
});

export const getAllBusinessListFailure = (fetchFailure: any) => ({
	type: BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_FAILURE,
	payload: fetchFailure,
});

export const getAllBusinessListResponseResetStart = () => ({
	type: BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_RESPONSE_RESET,
});

export const getAllBusinessListResponseChanged = () => ({
	type: BusinessDetailsActionTypes.GET_ALL_BUSINESS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ALL BUSINESS LIST END *********************** */

/** ***************** BUSINESS DETAILS EXIST CHECK START *********************** */
export const checkBusinessDetailsExistStart = (businessData: any) => ({
	type: BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_START,
	payload: businessData,
});

export const checkBusinessDetailsExistSuccess = (response: any) => ({
	type: BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_SUCCESS,
	payload: response,
});

export const checkBusinessDetailsExistFailure = (error: any) => ({
	type: BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_FAILURE,
	payload: error,
});

export const checkBusinessDetailsExistReset = () => ({
	type: BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_RESET,
});

export const checkBusinessDetailsExistResponseChanged = () => ({
	type: BusinessDetailsActionTypes.CHECK_BUSINESS_DETAILS_EXIST_RESPONSE_CHANGED,
});
/** ***************** BUSINESS DETAILS EXIST CHECK END *********************** */

/** ***************** BUSINESS APPROVE DETAILS START *********************** */
export const isBusinessApproveStart = (approveData: any) => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_START,
	payload: approveData,
});

export const isBusinessApproveSuccess = (response: any) => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_SUCCESS,
	payload: response,
});

export const isBusinessApproveFailure = (error: any) => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_FAILURE,
	payload: error,
});

export const isBusinessApproveReset = () => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_RESET,
});

export const isBusinessApproveResponseChanged = () => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_APPROVE_RESPONSE_CHANGED,
});
/** ***************** BUSINESS APPROVE DETAILS END *********************** */

export const isBusinessIdStart = (data: any) => ({
	type: BusinessDetailsActionTypes.IS_BUSINESS_ID_START,
	payload: data,
});
